import { render } from "./ProductCardWide.vue?vue&type=template&id=6ccb7762&scoped=true"
import script from "./ProductCardWide.vue?vue&type=script&lang=js"
export * from "./ProductCardWide.vue?vue&type=script&lang=js"

import "./ProductCardWide.vue?vue&type=style&index=0&id=6ccb7762&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ccb7762"]])

export default __exports__